<template>
  <div>
    <div class="box-body">
      <div class="col-md-12">
        <div class="row">
          <button
            type="button"
            class="btn btn-primary pull-right"
            @click="onAddNew"
          >
            <i class="glyphicon glyphicon-plus"></i>
            {{ $t("common.addnew") }}
          </button>
        </div>
      </div>
      <div class="col-md-12">
        <table class="table table-striped">
          <thead class="thead-dark">
            <tr>
              <th scope="col">
                {{ $t("common.nonumber") }}
              </th>
              <th scope="col">{{ $t("externalLink.externalLinkTitle") }}</th>
              <th scope="col">{{ $t("externalLink.iconAppMobile") }}</th>
              <th scope="col">{{ $t("externalLink.urlAddress") }}</th>
              <th scope="col">{{ $t("externalLink.status") }}</th>
              <th scope="col">{{ $t("common.historyaction") }}</th>
            </tr>
          </thead>
          <draggable
            v-model="extarnalLinkList"
            v-bind="dragOptions"
            @update="updateShort"
            @start="isDragging = true"
            @end="isDragging = false"
            tag="tbody"
          >
            <tr v-for="element in extarnalLinkList" :key="element.order">
              <td scope="row">{{ element.order }}.</td>
              <td scope="row">{{ element.title }}</td>
              <td scope="row">
                <img
                  id="apartment-img-id"
                  class="asset-img-class img-responsive"
                  :src="
                    isEmptyString(element.iconUrl)
                      ? noImgDefault
                      : element.iconUrl
                  "
                  @click="
                    isEmptyString(element.iconUrl)
                      ? ''
                      : onOpenImg(element.iconUrl)
                  "
                  alt="asset-img"
                />
              </td>
              <td scope="row">{{ element.urlAddress }}</td>
              <td scope="row">
                <i
                  v-if="element.enable"
                  style="font-size: x-large; color: green"
                  class="glyphicon glyphicon-ok-sign"
                ></i>
                <i
                  v-else
                  style="font-size: x-large; color: red"
                  class="glyphicon glyphicon-remove-sign"
                ></i>
              </td>
              <td scope="row" style="white-space: nowrap; width: 1%;">
                <button
                  type="button"
                  class="btn btn-labeled btn-info glyphicon glyphicon-edit"
                  style="margin: 0 2px 0 2px"
                  @click="onEdit(element)"
                ></button>
                <button
                  type="button"
                  class="btn btn-labeled btn-danger glyphicon glyphicon-trash"
                  style="margin: 0 2px 0 2px"
                  @click="onDelete(element)"
                ></button>
              </td>
            </tr>
          </draggable>
        </table>
      </div>
    </div>
    <!--  -->
    <external-link-modal
      ref="externalLinkModal"
      @callbackExternalLinkList="getExternalLink"
    />
    <!--  -->
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <!--  -->
    <lte-modal
      v-show="isModalVisible"
      @onConfirm="onConfirm"
      @close="closeModal"
      v-for="obj in objModal"
      :key="obj.id"
      :item="obj"
    ></lte-modal>
  </div>
</template>
<script>
import draggable from "vuedraggable";
import ExternalLinkModal from "./ExternalLinkModal";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import LTEModal from "@/components/LTEModal.vue";
import { mapActions, mapGetters } from "vuex";
import configuration from "@/lib/config";
import utils from "@/lib/utils";

export default {
  components: {
    draggable,
    ExternalLinkModal,
    "lte-core-alert": LTECoreAlert,
    "lte-modal": LTEModal
  },
  data: () => ({
    noImgDefault: configuration.imgUrlConfig.img_other_no_picture_available,
    extarnalLinkList: [],
    extarnalLinkSelect: null,
    isModalVisible: false,
    objModal: [
      {
        title: "common.delete_modal.title",
        body: "common.delete_modal.content",
        buttonNo: "common.delete_modal.btnNo",
        buttonYes: "common.delete_modal.btnYes",
        styleType: "default"
      }
    ],
  }),
  watch: {
    GET_EXTERNAL_LINK_LIST_DATA: function() {
      let data = this.GET_EXTERNAL_LINK_LIST_DATA;
      this.extarnalLinkList = [];
      data.forEach((v, index) => {
        let item = {
          id: v.id,
          order: index + 1,
          title: v.title,
          urlAddress: v.external_link,
          priority: v.priority,
          enable: v.enable,
          iconUrl: v.icon_url
        };
        this.extarnalLinkList.push(item);
      });
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 300,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_EXTERNAL_LINK_LIST_DATA"
    ])
  },
  methods: {
    isEmptyString: function(value) {
      return utils.isEmptyString(value);
    },
    updateShort(evt) {
      this.reorder(evt.oldIndex, evt.newIndex);
      // update short
      this.updatePriority()
    },
    reorder(oldIndex, newIndex) {
      // move the item in the underlying array
      // update order property based on position in array
      this.extarnalLinkList.splice(
        oldIndex,
        0,
        this.extarnalLinkList.splice(oldIndex, 1)[0]
      );
      this.extarnalLinkList.forEach(function(item, index) {
        item.order = index + 1;
      });
    },
    onAddNew: function() {
      this.$refs.externalLinkModal.addNew();
    },
    onEdit: function(data) {
      this.$refs.externalLinkModal.showDetail(data);
    },
    onOpenImg: function(url) {
      window.open(url);
    },
    getExternalLink: function() {
      this.GET_EXTERNAL_LINK_LIST();
    },
    updatePriority: function() {
      let data = {
        list: this.extarnalLinkList
      }
      this.UPDATE_PRIORITY_EXTERNAL_LINK(data)
        .then(
          function() {
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function(error) {
            this.ON_SHOW_TOAST({
              message: error.response.data.message,
              styleType: "danger"
            });
          }.bind(this)
        );
    },
    onDelete: function(data) {
      this.extarnalLinkSelect = data
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    onConfirm: function() {
      this.isModalVisible = false;
      this.DELETE_PRIORITY_EXTERNAL_LINK(this.extarnalLinkSelect)
        .then(
          function() {
            this.getExternalLink();
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    ...mapActions([
      "SUCCESS_TOAST",
      "GET_EXTERNAL_LINK_LIST",
      "UPDATE_PRIORITY_EXTERNAL_LINK",
      "DELETE_PRIORITY_EXTERNAL_LINK"
    ])
  },
  mounted() {
    this.getExternalLink();
  }
};
</script>
<style scoped>
.asset-img-class {
  /* margin: auto; */
  width: 100%;
  max-width: 75px;
  max-height: 75px;
  object-fit: contain;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/HomeMobileManagement/ExternalLinkManagement.vue